// Dependencies
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, Route, Switch, withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import axios from "axios";
import config from "../../libs/config";
import Loader from "../../components/Loader";
// Components & Containers
import "./style.css";
import Home from "../Home";
import Header from "../Header";
import Footer from "../Footer";
import StorieDetail from "../StorieDetail";

export default class Landing extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedLan: "en", // handle selected before change content with State.lan
      content: undefined
    };
  }

  handleLanguage = lan => {
    this.setState({ selectedLan: lan.toLowerCase() }, () => {
      this.props.handleLanguage(this.state.selectedLan);
    });
  };
  componentDidMount = () => {
    this.getContentData();
  };

  getContentData = () => {
    axios.get(`${config.BASE_URL}/site/${this.state.selectedLan}`).then(res => {
      console.log("res", res);
      this.setState({ content: res.data.site, lan: this.state.selectedLan });
    }); // fix
  };

  render() {
    const { content, selectedLan } = this.state;
    const { match, location, history } = this.props;
    return content === undefined ? (
      <Loader />
    ) : (
      <React.Fragment>
        <Header
          handleLanguage={this.handleLanguage}
          cucuta={content.cucuta[selectedLan].title}
          cucutaurl={content.cucuta[selectedLan].url}
        />
        <Route
          exact
          path={`${match.url}`}
          render={() => <Home lan={this.state.selectedLan} />}
        />
        <Footer />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Landing/index.jsx